<template>
  <article class="changelog-entry-card">
    <img
      v-if="entry.heroImageUrl"
      :src="entry.heroImageUrl"
      :alt="entry.title"
      class="changelog-entry-card__hero">
    <time class="changelog-entry-card__date">{{ formattedDate }}</time>
    <h3 class="changelog-entry-card__title">
      {{ entry.title }}
    </h3>
    <!-- contentHtml is sanitized server-side (allow-listed tags/attrs, iframes
         restricted to trusted video hosts) — see Changelog::Entry. -->
    <!-- eslint-disable-next-line vue/no-v-html -->
    <div class="documentation-prose changelog-entry-card__body" v-html="entry.contentHtml" />
    <ChangelogReactionBar :entry="entry" />
  </article>
</template>

<script setup>
import { computed } from 'vue'
import ChangelogReactionBar from './ChangelogReactionBar.vue'

const props = defineProps({
  entry: { type: Object, required: true }
})

const formattedDate = computed(() => new Date(props.entry.publishedAt)
  .toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }))
</script>
